import React from 'react';
import _ from 'lodash';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {STATUS_APPROVED} from 'app-ui-componentlibrary/dist/common/constants';
import {toDisplayDate, toSysDate} from 'common/utils';
import moment from 'moment';

export class PaymentStartDateListener extends React.Component {
  state = {
    initializing: true,
  };

  componentDidMount() {
    const {grant, payload, payments} = this.props;
    if (
      !_.get(grant, 'loading', true) &&
      payload !== undefined &&
      payments !== undefined &&
      !_.get(payments, 'loading', true)
    ) {
      this.generatePaymentStartDate();
    }
  }

  componentDidUpdate() {
    const {grant, payments} = this.props;
    const {initializing} = this.state;
    if (
      !_.get(grant, 'loading', true) &&
      initializing &&
      payments &&
      !_.get(payments, 'loading', true)
    ) {
      this.generatePaymentStartDate();
    }
  }

  generatePaymentStartDate = () => {
    const {grant, entityDataPath, entityType, payload, payments} = this.props;

    // Find last approved payment date
    const latestPaymentsDate = _.chain(payments)
      .omit('loading')
      .filter((payment) => payment.status === STATUS_APPROVED)
      .sortBy((payment) => moment(_.get(payment, 'payload.request.endDate')))
      .last()
      .get('payload.request.endDate')
      .value();

    const paymentFromPayload = _.get(payload, 'request.startDate');

    let paymentStartDate = '';

    if (
      latestPaymentsDate &&
      (!paymentFromPayload || paymentFromPayload !== latestPaymentsDate)
    ) {
      paymentStartDate = moment(latestPaymentsDate).add(1, 'days');
    } else {
      // Use POP start date from grant
      paymentStartDate = _.get(grant, 'payload.periodOfPerformance.startDate');
    }

    this.setState(
      {
        initializing: false,
      },
      () =>
        this.props.saveEntityData(entityDataPath, entityType, toSysDate(paymentStartDate))
    );
  };

  render() {
    return null;
  }
}

export default connectDynamic(PaymentStartDateListener);
